export const environment = {
  version: '2.4.7',
  production: false,
  apiURL: 'https://api-wos-dev2.agilecollab.com/',
  versionCheckURL:'https://salesrep-stg-wos-python.agilecollab.com/version.json',
  environment: 'staging',
  apiVersion: 'v3',
  username: 'appuser@mailinator.com',
  password: 'Admin@123456',
  client_id: 'Qp3IFurNh9hKL9WcwSPTpDaKce1p6bwXrFGvFpjG',
  profile_s3_path: 'https://ds9rxnkva2h7p.cloudfront.net',
  s3_path: 'https://ds9rxnkva2h7p.cloudfront.net',
  product_image_folder:'thumbnails',
  client_secret: 'bZ3s1CEFYweEaLXiy9CIU7nFYkRwodeLfQ2o5JwqD4DeeL4nwRnbcKahwJhHW4aRGdaiVrHhmbOnrcV2iWPgrwbOA1oamAjlQZ6DFHnVsJRedLR4vkFh9BNckCkQVFeD',
  grant_type: 'password',
  address_lookup_key: 'YU99-UT62-RZ43-JH12',
  dropdown_limit: 100,
  magentoApiUrl:'https://api-wos-dev2.agilecollab.com/',
  magentoApiVersion:'V1',
  page_size: 10,
  profileFolder:'ordering/profile-images/',
  hashedSecretKey:'f38ecf5379324f565d0365be0547b42e',
  hashedIV:'186DE986FC69F8E4',
};
